import React from 'react';
import { Box, TextField } from '@mui/material';
import { Label16SemiBold } from 'components';
import { fieldStyles } from '../styles';

interface TitleInputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: string;
}

export const TitleInput = ({ value, onChange, error }: TitleInputProps) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', maxWidth: '300px' }}>
        <Label16SemiBold>Emissions Allocation Setup Title *</Label16SemiBold>
        <TextField
            name="title"
            size="small"
            value={value}
            onChange={onChange}
            fullWidth
            required
            variant="outlined"
            error={!!error}
            helperText={error}
            sx={fieldStyles}
            inputProps={{ 'aria-label': 'Emissions Allocation Title' }}
        />
    </Box>
);